<template>
  <b-col class="">

    <p> قابل پرداخت: <span class="mx-1">  {{ formatNumber(price) }}   </span></p>
    <p> بدون تخفیف:<span class="mx-1">    {{ formatNumber(price_without_offer) }}      </span></p>
    <p> تخفیف:<span class="mx-1">     {{ formatNumber(offer) }}      </span></p>

  </b-col>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  subProducts,
  productPriceOnUnAuthShoppingCard
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {findHashProductOnLocalStorage} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';


export default {
  name: "UnAuthenticateSummary1",
  props: {
    products: {}
  },
  data() {
    return {
      price: 0,
      offer: 0,
      price_without_offer: 0,
    }
  },
  methods: {
    formatNumber,
    productPriceOnUnAuthShoppingCard,
    findHashProductOnLocalStorage,
    summary() {

      this.price = 0
      this.offer = 0
      this.price_without_offer = 0

      this.products.forEach(product => {
        subProducts(product).forEach(sub_product => {
          let item_in_storage = this.findHashProductOnLocalStorage(sub_product);
          if (item_in_storage !== undefined) {
            // convert local storage object to json to find item on it with index and extract quantity
            let productQuantity = JSON.parse(localStorage.getItem('products'))[item_in_storage]['quantity'];
            let sumPriceWithoutOffer = parseInt(this.productPriceOnUnAuthShoppingCard(sub_product)['price']) * productQuantity
            let sumOffer = parseInt(this.productPriceOnUnAuthShoppingCard(sub_product)['offer']) * productQuantity


            this.price_without_offer += sumPriceWithoutOffer
            this.offer += sumOffer
            this.price += (sumPriceWithoutOffer - sumOffer)
          }
        })
      })

      return true

    },
  },
  mounted() {
    window.addEventListener('click', this.summary);
    window.addEventListener('DOMContentLoaded', this.summary);
  },
  watch: {
    'products': {
      handler(newValue, oldValue) {
        this.summary()
      }
    }
  }
}
</script>

<style scoped>

</style>